import { defineComponent as _defineComponent } from 'vue'
import { Pagination, Grid, Navigation } from 'swiper'


export default /*@__PURE__*/_defineComponent({
  __name: 'Spotlight',
  props: {
    total: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const modules = [Pagination, Grid, Navigation]

const props = __props

function initFraction(swiper: any) {
  // fraction pagination manual update
  const fractionEl = document.querySelector('.js-spotlight-pagination-fraction')
  if (!fractionEl) return

  function updateFraction() {
    fractionEl.textContent = `${swiper.realIndex + 1} / ${props.total}`
  }

  updateFraction()
  swiper.on('slideChange', updateFraction)
}

const breakpoints = {
  0: {
    slidesPerView: 1,
    spaceBetween: 20,
  },
  564: {
    slidesPerView: 2,
    spaceBetween: 20,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 30,
    'centeredslides': true,

  },
  1200: {
    slidesPerView: 3,
    spaceBetween: -6,
    initialSlide: 1,
    'centeredSlides': true,

    // grid: {
    //   rows: 4,
    // },
  },
}

const __returned__ = { modules, props, initFraction, breakpoints, get Pagination() { return Pagination }, get Grid() { return Grid }, get Navigation() { return Navigation } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})